module.exports = "/_next/static/images/north-carolina-971c8e3145be25139385c6dff42a9f64.svg";